import script from "./MedicationSearchAutoComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./MedicationSearchAutoComplete.vue?vue&type=script&setup=true&lang=js"

import "./MedicationSearchAutoComplete.vue?vue&type=style&index=0&id=d5f919d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5f919d2"]])

export default __exports__